import _ from 'lodash';
import { FROM_USER_CHALLENGE_ID } from '@reduxConstants/create-challenge';

const getChallengeById = (challenges = [], id) =>
  _.find(challenges, (c) => c[FROM_USER_CHALLENGE_ID] === id);

export { getChallengeById };
